// frontend/src/api/norran.js
//
// ОБРАЩЕНИЕ К NORRAN — ЧЕРЕЗ СВОЙ BACKEND, А НЕ НАПРЯМУЮ.
//
// 🔴 ПОЧЕМУ ИМЕННО ТАК (обе причины замерены, см. NORRAN_REST_API.txt §0):
//
//    1. CORS. Домена Студии НЕТ в списке `origin` NORRAN. Прямой вызов
//       из браузера упадёт: OPTIONS отвечает 204, но БЕЗ заголовка
//       `Access-Control-Allow-Origin`.
//    2. ТОКЕН. Токен NORRAN даёт доступ к чужой системе — в браузере
//       клиента его увидит любой через DevTools.
//
//    Поэтому здесь НЕТ ни адреса NORRAN, ни токена: браузер знает только
//    про наш `/api/v1/norran/*`, а в NORRAN ходит сервер Студии.

import client from './client.js';

export const norranAPI = {
  /**
   * Считает цену изделия.
   *
   * @param {string} calculatorCode — код калькулятора NORRAN
   *        (из `product.norran_calculator_code`, НЕ из `calculator_id`)
   * @param {object} params — параметры формы
   *
   * ⚠️ `companyId` НЕ передаём: арендатора подставляет сервер из своей
   *    конфигурации. Иначе клиент мог бы посчитать чужой тенант.
   */
  calculate: (calculatorCode, params = {}) => {
    return client.post(`/norran/products/${calculatorCode}/calculate`, params);
  },

  /**
   * Проверяет, настроен ли расчёт для калькулятора.
   *
   * 🔑 Нужно, чтобы отличить «товар считаемый» от «код есть, но операций
   *    нет»: у `ploskie_bukvy` и `svetovye_bukvy` в NORRAN 0 шагов,
   *    и расчёт вернёт ошибку. Витрина не должна обещать цену, которой нет.
   */
  getCalculator: (calculatorCode) => {
    return client.get(`/norran/products/${calculatorCode}/calculator`);
  },

  /** Состояние интеграции — для диагностики */
  health: () => {
    return client.get('/norran/health');
  },
};

export default norranAPI;
